import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import useStyles from './style';
import Typography from '../../atoms/Typography';
import Button from '../../atoms/Button';
import get from 'lodash/get';
import { GOOGLE_DIRECTION_URL } from '../../../../constants';
import { EVENT_LIST_TEMPLATE_NAME } from './constants';
import { EVENTS_THEME_COLOR } from '../../../../constants';
import { pushAnaylyticsData, createDynamicLabels } from '../../../../utils/analytics';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { getDictionaryText } from '../../../utils/getDictionaryText';


const abuDhabiText = getDictionaryText('abuDhabiText');
const getAbuDhabiText = abuDhabiText === 'abuDhabiText' ? 'Abu Dhabi' : abuDhabiText;

const InfoWindow = props => {
  const classes = useStyles();
  const { marker, labels, sitecoreContext, pageName, componentName } = props;
  const contentType = get(
    sitecoreContext,
    'route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();
  const getDirText = get(labels, 'GetDirections.value', '');

  const addAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.getDirectionsLinkClick,
      ...{ label: createDynamicLabels([pageName, componentName, marker && marker.name]) },
    };
    pushAnaylyticsData(obj)
  }

  return (
    <div className={classes.infoWindow}>
      <Typography variant="h5" component="h3" className={classes.infoTitle}>
        {marker.name}
      </Typography>
      <Typography variant={'body2'} component={'p'} className={classes.address}>
        {marker.address}
      </Typography>
      <Button
        onClick={addAnalyticsInfo}
        className={classes.directionBtn}
        component="span"
        buttonType="secondary"
        field={{
          value: {
            text: getDirText,
            // href: `${GOOGLE_DIRECTION_URL}?api=1&destination=${marker.lat},${marker.lng}`,
            href: `${GOOGLE_DIRECTION_URL}Current+Location/${marker.name},${marker.address},${getAbuDhabiText}/@${marker.lat},${marker.lng}`,
            target: '_blank',
          },
        }}
        isStartIcon={true}
        hasBorder={false}
        rel={'noopener'}
        // This comments for Event page
        themeColor={
          contentType === EVENT_LIST_TEMPLATE_NAME ? EVENTS_THEME_COLOR : ''
        }
      >
        <Typography component="span" variant="body2Bold">
          {getDirText}
        </Typography>
      </Button>
    </div>
  );
};

export default withSitecoreContext()(InfoWindow);
